module.exports = __webpack_public_path__ + "static/media/Close.1f7d35a8.svg";